import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import * as Sentry from '@sentry/react';
import 'antd/dist/reset.css';
import { store } from './store';
import './index.css';
import './locales';
import './config/dayjs.config';
import App from './App';
import { env } from './config/env';

if (env.SENTRY_DSN) {
  Sentry.init({
    dsn: env.SENTRY_DSN,
    environment: env.environment,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

const SentryApp = Sentry.withErrorBoundary(App, {
  fallback: ({ error, resetError }) => {
    const errorMessage = error instanceof Error ? error.message : String(error);
    return (
      <div>
        <h2>Something went wrong:</h2>
        <p>{errorMessage}</p>
        <button onClick={resetError}>Try again</button>
      </div>
    );
  },
  showDialog: true,
});

const container = document.getElementById('root')!;
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <SentryApp />
  </Provider>,
);
